module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo26-501abb76ebb5388b5248a8d2bc58a97a.jpg";